import { LOGO_CIRCLE_IMAGE } from '../logoImages/logoCircleImage';
import { LOGO_HALF_FLAKE_IMAGE } from '../logoImages/logoHalfFlakeImage';
import { LOGO_HALF_LEAF_IMAGE } from '../logoImages/logoHalfLeafImage';

/** The company logo: half a leaf left, half a snowflake right, in one circle. */
export const SnowAndLandLogoSvg = ({ size = 35 }: { size?: number }) => {
  return (
    <svg
      version='1.2'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 1000 1000'
      height={size}
      width={size}
    >
      <title>roger-logo</title>
      <defs>
        <image {...LOGO_HALF_LEAF_IMAGE} id='companyLogoHalfLeaf' />
        <image {...LOGO_CIRCLE_IMAGE} id='companyLogoCircle' />
        <image {...LOGO_HALF_FLAKE_IMAGE} id='companyLogoHalfFlake' />
      </defs>
      <use href='#companyLogoHalfLeaf' x='0' y='0' />
      <use href='#companyLogoCircle' x='0' y='0' />
      <use href='#companyLogoHalfFlake' x='371' y='0' />
    </svg>
  );
};
